import { GridColDef } from "@mui/x-data-grid";
import { createdAtmodifiedAtActions } from "../../../../../helpers/appHelpers";

export const Columns: GridColDef[] = [
	{
		field: "name",
		headerName: "Name",
		minWidth: 230,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	{
		field: "countryCode",
		headerName: "Country Code",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	
	...createdAtmodifiedAtActions
];
